__turbopack_context__.v({
  "chatLink": "NpiRequestModal-module-scss-module__zArEcG__chatLink",
  "errorBlock": "NpiRequestModal-module-scss-module__zArEcG__errorBlock",
  "errorMessage": "NpiRequestModal-module-scss-module__zArEcG__errorMessage",
  "modal": "NpiRequestModal-module-scss-module__zArEcG__modal",
});
